

















import { DashboardService } from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({})
export default class DeltaAssinantesDiaCard extends Vue {
  deltaAssinantes: number | null = null;

  loading = true;
  @Prop() readonly date!: string | null;

  mounted() {
    this.fetch();
  }

  @Watch("date")
  async fetch() {
    this.limparAssinantes();
    if (this.date) {
      this.loading = true;
      this.deltaAssinantes = await DashboardService.obterAssinantesDeltaDiario(
        this.date
      ).finally(() => (this.loading = false));
    }
  }

  limparAssinantes() {
    this.deltaAssinantes = null;
  }
}
